<script setup>
import appleImg from "@images/front-pages/landing-page/apple-icon.png"
import googlePlayImg from "@images/front-pages/landing-page/google-play-icon.png"
import footerDarkBg from "@images/front-pages/backgrounds/footer-bg-dark.png"
import footerLightBg from "@images/front-pages/backgrounds/footer-bg-light.png"
import facebookDark from "@images/front-pages/icons/facebook-dark.png"
import facebookLight from "@images/front-pages/icons/facebook-light.png"
import githubDark from "@images/front-pages/icons/github-dark.png"
import githubLight from "@images/front-pages/icons/github-light.png"
import instagramDark from "@images/front-pages/icons/instagram-dark.png"
import instagramLight from "@images/front-pages/icons/instagram-light.png"
import twitterDark from "@images/front-pages/icons/twitter-dark.png"
import twitterLight from "@images/front-pages/icons/twitter-light.png"
import mainLogo from "@images/brand/alomonshi-symbol.png"
import { VNodeRenderer } from "@layouts/components/VNodeRenderer"
import { themeConfig } from "@themeConfig"

const github = useGenerateImageVariant(githubLight, githubDark)
const twitter = useGenerateImageVariant(twitterLight, twitterDark)
const facebook = useGenerateImageVariant(facebookLight, facebookDark)
const instagram = useGenerateImageVariant(instagramLight, instagramDark)
const footerBg = useGenerateImageVariant(footerLightBg, footerDarkBg)

const mediaList = ref([
  {
    title: "github",
    icon: github,
    href: "https://github.com/pixinvent",
  },
  {
    title: "facebook",
    icon: facebook,
    href: "https://www.facebook.com/pixinvents/",
  },
  {
    title: "twitter",
    icon: twitter,
    href: "https://twitter.com/pixinvents",
  },
  {
    title: "instagram",
    icon: instagram,
    href: "https://www.instagram.com/pixinvents/",
  },
])
</script>

<template>
  <div class="footer">
    <div
      class="footer-top pt-9"
      :style="{ 'background-image': `url(${footerBg})` }"
    >
      <VContainer>
        <VRow>
          <!-- 👉 Footer  -->
          <VCol cols="12" md="6">
            <div
              class="mb-4"
              :class="$vuetify.display.smAndDown ? 'w-100' : 'w-75 mr-6'"
            >
              <div class="d-flex align-center gap-x-3 mb-4">
                <VImg
                  :src="mainLogo"
                  alt="لوگوی الومنشی"
                  :max-width="50"
                  class=""
                />
                <h3 class="text-h3 text-white text-capitalize">الومنشی</h3>
              </div>
              <div
                class="mb-6 text-sm"
                :class="
                  $vuetify.theme.current.dark
                    ? 'text-body-1'
                    : 'text-white-variant'
                "
              >
                این یک متن نمونه است که به‌صورت موقت در صفحات وب، اپلیکیشن‌ها و
                طرح‌های گرافیکی قرار می‌گیرد. اپلیکیشن‌ها و طرح‌های گرافیکی قرار
                می‌گیرد
              </div>
              <VForm class="subscribe-form d-flex align-center">
                <VBtn
                  class="align-self-end rounded-e-0"
                  height="40"
                  color="primary"
                >
                  ایمیل
                </VBtn>
                <AppTextField
                  label=""
                  placeholder="aloo@email.co"
                  density="compact"
                />
              </VForm>
            </div>
          </VCol>

          <!-- 👉 Download App -->
          <VCol cols="12" md="6">
            <div>
              <div class="font-weight-medium mb-6">دانلود اپلیکیشن</div>

              <div>
                <VBtn
                  v-for="(item, index) in [
                    { image: appleImg, store: 'App Store' },
                    { image: googlePlayImg, store: 'Google Play' },
                  ]"
                  :key="index"
                  color="#282C3E"
                  size="x-large"
                  height="70px"
                  class="mb-4 d-block"
                >
                  <template #default>
                    <div class="d-flex gap-x-3">
                      <div>
                        <VImg :src="item.image" height="34" width="34" />
                      </div>
                      <div class="d-flex flex-column justify-content-start">
                        <div
                          :class="
                            $vuetify.theme.current.dark
                              ? 'text-body-2'
                              : 'text-white-variant text-base'
                          "
                          class="font-weight-normal"
                        >
                          Download on the
                        </div>
                        <div
                          class="font-weight-medium text-start"
                          :class="
                            $vuetify.theme.current.dark
                              ? 'text-body-1'
                              : 'text-white-variant text-base'
                          "
                        >
                          {{ item.store }}
                        </div>
                      </div>
                    </div>
                  </template>
                </VBtn>
              </div>
            </div>
          </VCol>
        </VRow>
      </VContainer>
    </div>

    <!-- 👉 Footer Line -->
    <div class="text-white-variant footer-line w-100 px-5">
      <VContainer>
        <div
          class="d-flex justify-space-between flex-wrap gap-y-4 align-center"
        >
          <div class="d-flex gap-x-5">
            <a
              v-for="(item, index) in mediaList"
              :key="index"
              :href="item.href"
              target="_blank"
              rel="noopener noreferrer"
            >
              <VAvatar size="16" class="rounded-0">
                <VImg :src="item.icon" width="16" />
              </VAvatar>
            </a>
          </div>

          <span class="text-wrap me-4">
            <a
              href=""
              target="_blank"
              rel="noopener noreferrer"
              class="font-weight-bold ms-1 text-white"
            >
              aloomonshi
            </a>

            &copy;

            {{ new Date().getFullYear() }}
          </span>
        </div>
      </VContainer>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.footer-top {
  border-radius: 25px 25px 0 0;
  background-size: cover;
  color: #fff;
}

.footer-line {
  background: #171925;
}
</style>

<style lang="scss">
.subscribe-form {
  .v-label {
    color: rgba(211, 212, 220, 50%) !important;
  }

  .v-field {
    border-radius: 6px 0 0 6px !important;

    input.v-field__input::placeholder {
      color: rgba(231, 227, 252, 50%) !important;
    }
  }
}

.footer {
  border-radius: 50%;

  @media (min-width: 600px) and (max-width: 960px) {
    .v-container {
      padding-inline: 2rem !important;
    }
  }
}
</style>
